module.exports = __webpack_public_path__ + "static/media/advenio-simple-white.ac3147e8.svg";